import React, { useEffect, useState, useRef } from "react";
import api from "../lib/api";
import { Loader2 } from "lucide-react";

export default function TopTicker() {
  const [quotes, setQuotes] = useState([]);
  const [loading, setLoading] = useState(true);
  const trackRef = useRef(null);

  const load = async () => {
    try {
      const data = await api.getQuotes();
      setQuotes(data.quotes || []);
    } catch (e) {
      // ignore
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    const id = setInterval(load, 60000); // refresh every 60s
    return () => clearInterval(id);
  }, []);

  if (loading) {
    return (
      <div className="border-b border-zinc-800 bg-zinc-950/60 h-9 flex items-center px-4 text-xs text-zinc-500">
        <Loader2 size={12} className="animate-spin mr-2" /> Lade Quotes...
      </div>
    );
  }

  if (quotes.length === 0) {
    return (
      <div className="border-b border-zinc-800 bg-zinc-950/60 h-9 flex items-center px-4 text-[10px] uppercase tracking-widest text-zinc-600 font-display">
        Keine aktiven Setups · Live-Ticker startet sobald Setups angelegt sind
      </div>
    );
  }

  // Build a long marquee string by repeating quotes
  const items = [...quotes, ...quotes, ...quotes];

  return (
    <div className="border-b border-zinc-800 bg-zinc-950/60 h-9 overflow-hidden relative" data-testid="top-ticker">
      <div
        ref={trackRef}
        className="absolute top-0 left-0 h-full flex items-center gap-8 whitespace-nowrap animate-marquee"
        style={{ animation: `marquee ${Math.max(30, quotes.length * 8)}s linear infinite` }}
      >
        {items.map((q, idx) => {
          const ch = q.day_change_percent;
          const color = ch == null ? "text-zinc-500" : ch > 0 ? "text-emerald-400" : ch < 0 ? "text-rose-400" : "text-zinc-400";
          const sign = ch != null && ch > 0 ? "+" : "";
          const price = q.last_price != null ? Number(q.last_price).toLocaleString("de-DE", { maximumFractionDigits: 2 }) : "—";
          return (
            <div key={`${q.id}-${idx}`} className="flex items-center gap-2 text-xs font-mono-num">
              <span className="text-zinc-300 font-bold">{q.asset_name}</span>
              <span className="text-zinc-500 text-[10px]">{q.symbol}</span>
              <span className="text-white">{price}</span>
              <span className={color}>
                {ch != null ? `${sign}${ch.toFixed(2)}%` : "—"}
              </span>
              <span className="text-zinc-700">·</span>
            </div>
          );
        })}
      </div>
      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-33.33%); }
        }
      `}</style>
    </div>
  );
}
